"use client"

import Image from "next/image";
import LeadForm from "@/components/forms/LeadForm";
import { GroupedService } from "@/lib/services/services";

interface ContactSectionProps {
    lang?: string;
    title?: string;
    description?: string;
    image?: string | null;
    groupedServices?: GroupedService[];
    dict?: {
        form?: {
            name?: string;
            email?: string;
            phone?: string;
            send?: string;
            success?: string;
            error?: string;
            kvkk_consent?: string;
            marketing_consent?: string;
        };
    };
}

export default function ContactSection({ lang = "tr", title, description, image, dict }: ContactSectionProps) {
    return (
        <section className="bg-gray-50 py-14" id="contact">
            <div className="container-custom">
                <div className="flex h-auto flex-col overflow-hidden rounded-3xl shadow-2xl lg:min-h-[600px] lg:flex-row">
                    <div className="flex w-full flex-col justify-center bg-[#051e3c] p-8 lg:w-1/2 lg:p-12">
                        {title ? <h2 className="mb-2 text-2xl font-bold text-white">{title}</h2> : null}
                        {description ? (
                            <p className="mb-8 whitespace-pre-wrap text-[14px] leading-relaxed text-blue-100/70">
                                {description}
                            </p>
                        ) : null}

                        <LeadForm dict={dict} idPrefix="home-contact-form" lang={lang as "tr" | "en" | "ar"} />
                    </div>

                    <div className="relative w-full bg-gray-200 lg:w-1/2">
                        {image ? (
                            <Image
                                src={image}
                                alt={title || "Cinik Polikliniği"}
                                fill
                                className="object-cover"
                                sizes="(max-width: 1024px) 100vw, 50vw"
                            />
                        ) : (
                            <div className="flex h-full w-full items-center justify-center bg-[#e5e7eb] text-gray-400">
                                No Image Selected
                            </div>
                        )}
                        <div className="absolute inset-0 bg-[#051e3c]/20" />
                    </div>
                </div>
            </div>
        </section>
    );
}
